import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class TransitionService {
  private showTransitionSubject = new BehaviorSubject<boolean>(false)
  public showTransition$ = this.showTransitionSubject.asObservable()

  show (): void {
    this.showTransitionSubject.next(true)
  }

  hide (): void {
    this.showTransitionSubject.next(false)
  }
}
